import React from 'react';
import { Link } from 'react-router-dom';
import { technologies } from '../../data/learn';
import { courses } from '../../data/courses';
import { audiences } from '../../data/audiences';
import './index.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="logo">Codeazy</Link>
            <p>Learn the skills, crack the interview and land the job, with free lessons and live, mentor-led cohorts.</p>
          </div>

          <nav className="footer-col" aria-label="Learn">
            <h3>Learn</h3>
            <ul>
              {technologies.slice(0, 6).map((t) => (
                <li key={t.slug}><Link to={`/learn/${t.slug}`}>{t.name}</Link></li>
              ))}
              <li><Link to="/learn">All topics →</Link></li>
            </ul>
          </nav>

          <nav className="footer-col" aria-label="Programs">
            <h3>Programs</h3>
            <ul>
              {courses.map((c) => (
                <li key={c.title}><Link to="/#courses">{c.title}</Link></li>
              ))}
              <li><Link to="/live-classes">Live cohorts</Link></li>
              <li><Link to="/workshops">Free workshops</Link></li>
            </ul>
          </nav>

          <nav className="footer-col" aria-label="Who it's for">
            <h3>Who it&apos;s for</h3>
            <ul>
              {audiences.map((a) => (
                <li key={a.slug}><Link to={`/${a.slug}`}>{a.navLabel}</Link></li>
              ))}
            </ul>
          </nav>

          <nav className="footer-col" aria-label="Resources">
            <h3>Resources</h3>
            <ul>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/blog?category=Interview%20Tips">Interview tips</Link></li>
              <li><Link to="/live-classes#request-form">Request a seat</Link></li>
              <li><Link to="/#contact-form">Contact us</Link></li>
            </ul>
          </nav>
        </div>

        <div className="footer-bottom">
          <p>© {year} Codeazy. Making tech education accessible to everyone.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
